export default __webpack_public_path__ + "static/media/kitchenaid.7b1c5fe5.svg";